// angular
import { Component, inject, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// components
import { ButtonComponent } from '../button/button.component';
import { ConfirmationDialogComponent } from '@app/core/dialogs/confirmation-dialog/confirmation-dialog.component';
// services
import { CommentsService } from '@app/core/shared/services/comments.service';
import { DialogService } from '@app/core/shared/services/dialog.service';
// interfaces
import { ICommentData } from '@app/shared/interfaces/comment.interface';
// pipes & enums
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { PersianDatePipe } from '@app/shared/pipes/persian-date.pipe';
import { CommentStatusEnum } from '@app/core/shared/enums/commentStatus.enum';

@Component({
  selector: 'pwj-panel-comment',
  standalone: true,
  imports: [
    TranslateModule,
    ButtonComponent,
    TranslateDataPipe,
    DatePipe,
    RouterLink,
    PersianDatePipe,
  ],
  templateUrl: './panel-comment.component.html',
  styleUrl: './panel-comment.component.scss',
})
export class PanelCommentComponent {
  public currentLang!: string;
  public commentStatusEnum = CommentStatusEnum;

  // inputs
  commentData = input.required<ICommentData>();

  // dependencies
  private readonly _commentService = inject(CommentsService);
  private readonly _dialogService = inject(DialogService);
  private readonly _translateService = inject(TranslateService);

  constructor() {
    // set current lang
    this.currentLang = this._translateService.currentLang;
    // set lang on change
    this._translateService.onLangChange.subscribe(data => {
      this.currentLang = data.lang;
    });
  }

  public onDeleteComment(commentId: string) {
    // confirmation dialog
    const dialogRef = this._dialogService.open(ConfirmationDialogComponent, {
      width: '26em',
      height: '10em',
      data: { title: 'profile.comments.confirmDeleteComment' },
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this._commentService.removeCommentByUser(commentId);
      }
    });
  }
}
